import { useEffect, useState } from "react";

import { IconProp } from "@fortawesome/fontawesome-svg-core";
import { faUser } from "@fortawesome/free-solid-svg-icons";
import getTime from "../helpers/getTime";
import useCurrentUser from "./useCurrentUser";
import useEvent from "./useEvent";
import useLiveSession from "./useLiveSession";
import { useLocation } from "react-router-dom";

export interface MenuItemProps {
  icon?: IconProp;
  name?: string;
  link?: string;
  exact?: boolean;
  isActive?: () => boolean;
  dropdownID?: string;
  dropdown?: MenuItemProps[];
}

const useDynamicNav = () => {
  const event = useEvent();
  const currentUser = useCurrentUser();
  const { pathname } = useLocation();
  const { ticket } = currentUser || {};
  const { access } = ticket || {};
  const [items, setItems] = useState<MenuItemProps[]>([]);

  // Get live session
  const room1 = useLiveSession(1);
  const room2 = useLiveSession(2);
  const room3 = useLiveSession(3);

  useEffect(() => {
    const virtualRooms = [
      {
        name: "Virtual Room 1" + (room1 ? " LIVE" : ""),
        link: `/${event}/virtual-room/1`,
      },
      {
        name: "Virtual Room 2" + (room2 ? " LIVE" : ""),
        link: `/${event}/virtual-room/2`,
      },
      {
        name: "Virtual Room 3" + (room3 ? " LIVE" : ""),
        link: `/${event}/virtual-room/3`,
      },
    ];

    if (getTime() > getTime("28 Nov 2020")) {
      const SEAADEMenu = [
        {
          name: "SEAADE",
          dropdownID: "SEAADE",
          dropdown: [
            {
              name: "SEAADE Posters",
              link: "/SEAADE/posters",
            },
            {
              name: "SEAADE Post-events",
              link: "/SEAADE/sessions",
            },
            {
              name: "SEAADE Awards",
              link: "/SEAADE/awards",
            },
            {
              name: "SEAADE Evaluation",
              link: "/SEAADE/evaluation",
            },
          ],
        },
      ];

      const IADRMenu = [
        {
          name: "IADR",
          dropdownID: "IADR",
          dropdown: [
            {
              name: "IADR Posters",
              link: "/IADR/posters",
            },
            {
              name: "IADR Oral Presentations",
              link: "/IADR/sessions",
            },
            {
              name: "IADR Awards",
              link: "/IADR/awards",
            },
            {
              name: "IADR Evaluation",
              link: "/IADR/evaluation",
            },
          ],
        },
      ];

      const defaultMenu = [
        {
          name: "Expo",
          link: `/${event}/expo`,
        },
        {
          name: "Profile",
          link: `/${event}/profile`,
          icon: faUser,
        },
      ];

      if (access === "SEAADE-IADR") {
        setItems([...SEAADEMenu, ...IADRMenu, ...defaultMenu]);
      } else if (access === "SEAADE") {
        setItems([...SEAADEMenu, ...defaultMenu]);
      } else if (access === "IADR") {
        setItems([...IADRMenu, ...defaultMenu]);
      } else {
        setItems(defaultMenu);
      }
    } else {
      setItems([
        {
          name: "Reception",
          link: "/",
        },
        {
          name: "Virtual Room",
          dropdownID: "virtual-room",
          dropdown: virtualRooms,
        },
        {
          name: "Posters",
          link: `/${event}/posters`,
        },
        {
          name: "Video Sessions",
          link: `/${event}/sessions`,
        },
        {
          name: "Awards",
          link: `/${event}/awards`,
        },
        {
          name: "Expo",
          link: `/${event}/expo`,
        },
        {
          name: "Profile",
          link: `/${event}/profile`,
          icon: faUser,
        },
      ]);
    }
  }, [event, access, pathname, room1, room2, room3]);

  return items;
};

export default useDynamicNav;
